import { Post } from '@/ts/graphqlschema'

type TPostHeaderProps = {
  post: Post
}

export default function PostHeader(props: TPostHeaderProps) {
  const { post } = props

  if (post) {
    return (
      <section className="bg-primary">
        <div className="page-vertical-padding wrap-content">
          <div className="wrap-content">
            <h1 className="font-alegreya text-2xl md:text-4xl xl:text-5xl text-center">
              {post.title}
            </h1>
            {/*<p className="font-sans text-gray-8 text-center mx-auto py-4">*/}
            {/*  Published on {moment(detail.publish_date).format('ll')}*/}
            {/*</p>*/}
            {/*THUMBNAIL*/}
            {/*<div className="py-8 wrap-content">*/}
            {/*  <Image*/}
            {/*    className="w-10/12 mx-auto"*/}
            {/*    src={thumbnailUrl}*/}
            {/*    width={800}*/}
            {/*    height={400}*/}
            {/*    objectFit={'cover'}*/}
            {/*    alt={detail.title}*/}
            {/*  />*/}
            {/*</div>*/}
            <p className="max-w-sm lg:max-w-lg mt-3 mx-auto font-alegreya text-center text-xl xl:text-2xl">
              {post.description}
            </p>
          </div>
        </div>
      </section>
    )
  }
  return <div>Loading</div>
}
